import React from 'react'
import { Faq } from 'src/components/Faq/Faq'
import SEO from 'src/seo'
const FaqPage = () => {
  return (
    <div>
      <SEO title="FAQ's" />
      <Faq />
    </div>
  )
}
export { FaqPage }
